import "../Content/bootstrap-faraz.scss";
import "../Content/bootstrap-faraz-rtl.scss"; //Keep 2nd
import "../node_modules/react-widgets/scss/styles.scss"
import "@framework/Frames/Frames.css";
import "@extensions/Workflow/Case/Inbox.css";
import "../Content/site.css";

import * as React from "react"
import { Localization } from "react-widgets"
import { render, unmountComponentAtNode } from "react-dom"
import { Router, Route, Redirect, Switch } from "react-router"

import * as luxon from "luxon"
import * as moment from "moment-jalaali"

import { NumberFormatSettings, reloadTypes } from "@framework/Reflection"
import * as AppContext from "@framework/AppContext"
import * as Services from "@framework/Services"

import Notify from "@framework/Frames/Notify"
import ErrorModal from "@framework/Modals/ErrorModal"

import * as AuthClient from "@extensions/Authorization/AuthClient"
import * as WebAuthnClient from '@extensions/Authorization/WebAuthn/WebAuthnClient'
import * as CultureClient from "@extensions/Translation/CultureClient"
import * as LicenseClient from "@saturn/License/LicenseClient"
import * as PartyClient from "@saturn/Party/PartyClient"
import * as History from 'history'
import * as ConfigureReactWidgetsPersian from './ConfigureReactWidgetsPersian'
import { VersionChangedAlert } from "@framework/Frames/VersionChangedAlert";



import Home from './Home'
import NotFound from './NotFound'
import LoginPage from '@extensions/Authorization/Login/LoginPage'


import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { ImportRoute } from "@framework/AsyncImport";
import * as ConfigureReactWidgets from "@framework/ConfigureReactWidgets"
import FarazLogin from "./FarazLogin";
import { FarazPermission } from "./Faraz/Faraz.Entities";
import Layout from "./Layout";

library.add(fas, far);

AppContext.setTitleFunction(pageTitle => document.title = pageTitle ? pageTitle + " - Faraz" : "Faraz");
AppContext.setTitle();


declare let __webpack_public_path__: string;

__webpack_public_path__ = window.__baseUrl + "dist/";

let bootstrapFaraz: HTMLStyleElement;
let bootstrap: HTMLStyleElement;

const dateLocalizer = ConfigureReactWidgetsPersian.getDateLocalizer();
const numberLocalizer = ConfigureReactWidgets.getNumberLocalizer();

Services.NotifyPendingFilter.notifyPendingRequests = pending => {
  Notify.singleton && Notify.singleton.notifyPendingRequest(pending);
}

Notify.lockScreenOnLoading = true;

Services.VersionFilter.versionHasChanged = () => {
  VersionChangedAlert.forceUpdateSingletone && VersionChangedAlert.forceUpdateSingletone();
}

CultureClient.onCultureLoaded.push(ci => {
  const culture = ci.name;
  const rtlMode = culture.startsWith("fa");

  bootstrap = bootstrap || (bootstrap = document.head!.getElementsByTagName("style")[0]);
  bootstrapFaraz = bootstrapFaraz || (bootstrapFaraz = document.head!.getElementsByTagName("style")[1]);

  addRemove(bootstrap, !rtlMode);
  addRemove(bootstrapFaraz, rtlMode);

  AppContext.setRtl(rtlMode);

  if (rtlMode)
    document.body.classList.add("rtl");
  else
    document.body.classList.remove("rtl");

  const fullCulture =
    culture.startsWith("en") ? "en-GB" :
      culture.startsWith("fa") ? "fa-IR" :
        "Unkwnown";
       

  luxon.Settings.defaultLocale = fullCulture;
  NumberFormatSettings.defaultNumberFormatLocale = fullCulture;

  if (culture.startsWith("en")) {
    moment.locale("en-gb", {
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'YYYY/MM/DD',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm'
      },
    });
  }

  else if (culture.startsWith("fa")) {
    moment.locale("fa", {
      longDateFormat: {
      LT: 'HH:mm',
      LTS: 'HH:mm:ss',
      L: 'jYYYY/jMM/jDD',
      LL: 'jD jMMMM jYYYY',
      LLL: 'jD jMMMM jYYYY LT',
      LLLL: 'dddd، jD jMMMM jYYYY LT'
      },
    });
  }
  else
    throw new Error();
  
  NumberFormatSettings.defaultNumberFormatLocale = culture;
});

function addRemove(style: HTMLStyleElement, isVisible: boolean) {
  if (isVisible && !style.parentNode) {
    let child = document.head!.getElementsByTagName("style")[1];
    document.head!.insertBefore(style, child);
  }
  else if (!isVisible && style.parentNode)
    style.parentNode.removeChild(style);
}

Notify.lockScreenOnLoading = true;

Services.VersionFilter.versionHasChanged = () => {
  VersionChangedAlert.forceUpdateSingletone && VersionChangedAlert.forceUpdateSingletone();
}

Services.NotifyPendingFilter.notifyPendingRequests = pending => {
  Notify.singleton && Notify.singleton.notifyPendingRequest(pending);
}

AuthClient.registerUserTicketAuthenticator();

ErrorModal.register();

function reload() {


  return AuthClient.autoLogin()
    .then(() => LicenseClient.getLicensedModules())
    .then(() => LicenseClient.getLicenseInfo())
    .then(() => reloadTypes())
    .then(() => CultureClient.loadCurrentCulture())
    .then(() => {
      AppContext.clearAllSettings();
      const productName = LicenseClient.licenseInfo.productName;

      Services.SessionSharing.setAppNameAndRequestSessionStorage(productName);

      const routes: JSX.Element[] = [];

      AuthClient.startPublic({ routes, userTicket: true, windowsAuthentication: false, resetPassword: true, notifyLogout: true });

      if (LicenseClient.isLicensed("SignUp")) {
        PartyClient.start({ routes });
        FarazLogin.customLoginButtons = () => PartyClient.getSignUpButtonComponent();
      }

      AppContext.setTitleFunction(pageTitle => document.title = (pageTitle ? (pageTitle + " - ") : "") + productName);
      AppContext.setTitle();

      routes[routes.findIndex(a => a.props.path == "~/auth/login")] = <Route exact path="~/auth/login" component={FarazLogin} />;

      const isFull = Boolean(AuthClient.currentUser()) && AuthClient.currentUser().userName != "Anonymous"; //true;

      const promise = isFull ?
        import("./MainAdmin").then(main => main.startFull(routes)) :
        Promise.resolve(undefined);

      const messages = ConfigureReactWidgets.getMessages();

      return promise.then(() => {

        if (isFull) {
          routes.push(<Route exact path="~/" component={Home} />);
          routes.push(<Route component={NotFound} />);
        }
        else
          routes.push(<Redirect to="~/auth/login" />);

        Layout.switch = React.createElement(Switch, undefined, ...routes);
        const reactDiv = document.getElementById("reactDiv")!;
        unmountComponentAtNode(reactDiv);

        const h = AppContext.createAppRelativeHistory();

        render(
          <Localization date={dateLocalizer} number={numberLocalizer} messages={messages} >
            <Router history={h}>

            <Layout />
            </Router>
          </Localization>, reactDiv);

        return isFull;
      });
    });
}

AuthClient.Options.onLogin = (url?: string) => {
  reload()
    .then(() => import('@extensions/Workflow/WorkflowClient'))
    .then(workflowClient => {
      if (AuthClient.isPermissionAuthorized(FarazPermission.OpenInboxAsMainPage))

        AppContext.history.push(workflowClient.getDefaultInboxUrl());
      else {
        const loc = AppContext.history.location;
        const back: History.Location = loc && loc.state && (loc.state as any).back;
        AppContext.history.push(back ?? url ?? "~/");
      }

    }).done();
};

AuthClient.Options.onLogout = () => {
  AppContext.history.push("~/");
  reload().done();
};

reload().done();
